<div
    matTooltip="{{field.asDate(focusItem) | date:'long'}}">
    {{relativeToNowText}}
</div>